import { useMemo } from "react"

export type TableSizes = TableSizesDict | number[]

export interface TableSizesDict {
	xl?: number[]
	lg?: number[]
	md?: number[]
	sm?: number[]
	xs?: number[]
}

function isTableSizesDict(sizes: TableSizes): sizes is TableSizesDict {
	return !Array.isArray(sizes)
}

export const useTableSizes = (tableSizes: TableSizes | undefined) => {
	return useMemo(() => {
		if (!tableSizes) return undefined

		const breakpoints: (keyof TableSizesDict)[] = ["xl", "lg", "md", "sm", "xs"]
		const result: Record<keyof TableSizesDict, number[]> = {
			xl: [],
			lg: [],
			md: [],
			sm: [],
			xs: [],
		}

		if (isTableSizesDict(tableSizes)) {
			breakpoints.forEach((bp) => {
				result[bp] = tableSizes[bp] || []
			})
		} else {
			// If it's a number array, use the same values for all breakpoints
			breakpoints.forEach((bp) => {
				result[bp] = tableSizes
			})
		}

		return result
	}, [tableSizes])
}
